<template>
	<div class="base_table text-center">
		<div class="base_table_header">
			<table class="table w-full">
				<thead>
					<tr>
						<th
							v-for="(item, index) in column"
							:key="item.prop || `thead_${index}`"
							:style="`width: ${ item.width };word-break: break-word;`"
						>
							{{ item.label }}
						</th>
					</tr>
				</thead>
			</table>
		</div>
		<div class="base_table_body">
			<van-list v-model="modelLoading" :finished="finished" finished-text="没有更多了" @load="$emit('load')">
				<table class="table w-full">
					<tbody>
						<tr v-for="(val, idx) in tableData" :key="`tbody_tr_${idx}`">
							<td
								v-for="(item, index) in column"
								:key="item.prop || `tbody_td_${index}`"
								:style="`width: ${ item.width }`"
							>
								<slot v-if="item.slot" :name="item.prop" :column="item" :item="val"></slot>
								<span v-else>{{ val[item.prop] }}</span>
							</td>
						</tr>
					</tbody>
				</table>
			</van-list>
		</div>
	</div>
</template>

<script>
export default {
    name: 'BaseTable',
    props: {
        loading: {
            type: Boolean,
            default: false
        },
        finished: {
            type: Boolean,
            default: false
        },
        finishedText: {
            type: String,
            default: '没有更多了'
        },
        column: {
            type: Array,
            default: () => ([])
        },
        tableData: {
            type: Array,
            default: () => ([])
        }
    },
    computed: {
        modelLoading: {
            get () {
                return this.loading
            },
            set (val) {
                this.$emit('input', val)
            }
        }
    }
}
</script>

<style scoped lang="less">
.base_table {
	.table {
		border: 1px solid #f0f0f0;
		border-collapse: collapse;
		th,
		td {
			padding: 24.66px 14.5px;
			border: 1px solid #f0f0f0;
		}
	}
	.base_table_header {
		font-family: PingFangSC-Medium;
		font-size: 28px;
		font-weight: normal;
		color: #1f2329;
		background-color: #f8f8f8;
	}
	.base_table_body {
		font-family: PingFangSC-Regular;
		font-size: 28px;
		font-weight: normal;
		color: @gray-9;
	}
}
</style>
